const module = { name: 'movie/shared/desktop/videoLinksUI', exports: {} }; const exports = module.exports;



import { default as videoPlayer } from 'swug-fdRequire-call:desktop/shared/videoPlayer';



const Selectors = {
    MOVIE_VIDEO_LINK: '.js-movie-video-link'
}
function onPlayClick(e) {
    e.preventDefault();
    videoPlayer.show(e.currentTarget.href);
}
function attach() {
    document.querySelectorAll(Selectors.MOVIE_VIDEO_LINK)
        .forEach(video => video.addEventListener('click', onPlayClick));
}
module.exports = {
    attach
};
export default module.exports;